import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root',
})

export class HelpPlanService extends GenericService<any> {
    constructor(private http: HttpClient) {
        super(http,'/HelpPlan/', environment.Services.AlphaURLSlot2)
    } 

    getHelpPlansByDossierid(dossierId)
    {
        return this._http.get(
            this.url+"Dossier/HelpPlans/"+dossierId, this.prepareHeader()).pipe(map(res => res as any)
        );
    }

    getHelpPlansTravelLegs(dossierId){
        return this._http.get(this.url+"Dossier/HelpPlansTravelLegs/"+dossierId, this.prepareHeader()).pipe(map(res => res as any));
    }    
}